const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')

const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const program = () => import(/* webpackPrefetch: true */ '@/views/private/program/index.vue')
const program_detail = () => import(/* webpackPrefetch: true */ '@/views/private/program/_id.vue')
const program_add = () => import(/* webpackPrefetch: true */ '@/views/private/program/add/index.vue')
const program_edit = () => import(/* webpackPrefetch: true */ '@/views/private/program/edit/_id.vue')
const program_edit_realisasi = () => import(/* webpackPrefetch: true */ '@/views/private/program/realisasi/_id.vue')
const program_pengecualian = () => import(/* webpackPrefetch: true */ '@/views/private/program/pengecualian/_id.vue')

const program_perubahan = () => import(/* webpackPrefetch: true */ '@/views/private/program-perubahan/index.vue')
const program_perubahan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/program-perubahan/_id.vue')
const program_perubahan_add = () => import(/* webpackPrefetch: true */ '@/views/private/program-perubahan/add/index.vue')
const program_perubahan_edit = () => import(/* webpackPrefetch: true */ '@/views/private/program-perubahan/edit/_id.vue')
const program_perubahan_edit_realisasi = () => import(/* webpackPrefetch: true */ '@/views/private/program-perubahan/realisasi/_id.vue')
const program_perubahan_pengecualian = () => import(/* webpackPrefetch: true */ '@/views/private/program-perubahan/pengecualian/_id.vue')

const program_p1 = () => import(/* webpackPrefetch: true */ '@/views/private/program-p1/index.vue')
const program_p1_detail = () => import(/* webpackPrefetch: true */ '@/views/private/program-p1/_id.vue')
const program_p1_add = () => import(/* webpackPrefetch: true */ '@/views/private/program-p1/add/index.vue')
const program_p1_edit = () => import(/* webpackPrefetch: true */ '@/views/private/program-p1/edit/_id.vue')
const program_p1_edit_realisasi = () => import(/* webpackPrefetch: true */ '@/views/private/program-p1/realisasi/_id.vue')
const program_p1_pengecualian = () => import(/* webpackPrefetch: true */ '@/views/private/program-p1/pengecualian/_id.vue')

const laporan_perkembangan = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/perkembangan/index.vue')
const laporan_rekapitulasi = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/rekapitulasi/index.vue')
const laporan_rekapitulasi_gabungan = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/rekapitulasi-opd-gabungan/index.vue')
const laporan_kendala = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/kendala/index.vue')
const laporan_capaian = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/capaian/index.vue')

const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/_id.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/user/edit/_id.vue')

const perbandingan_sp2d = () => import(/* webpackPrefetch: true */ '@/views/private/perbandingan-sp2d/index.vue')

const laporan_rekap_opd_public = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/rekap-opd-public/index.vue')
const perkembangan_opd_public = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/perkembangan-opd-public/index.vue')

const laporan_summary_anggaran = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/summary-anggaran/index.vue')
const laporan_jumlah_program_kegiatan_sub = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/jumlah-program-kegiatan-sub/index.vue')

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },


  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },


  {
    path: "/program",
    name: "Program",
    component: program,
    meta: {
      title: "Program"
    }
  },
  {
    path: "/program/detail/:id",
    name: "Detail Program",
    component: program_detail,
    meta: {
      title: "Detail Program"
    }
  },
  {
    path: "/program/add",
    name: "Tambah Program",
    component: program_add,
    meta: {
      title: "Tambah Program"
    }
  },
  {
    path: "/program/edit/:id",
    name: "Ubah Program",
    component: program_edit,
    meta: {
      title: "Ubah Program"
    }
  },
  {
    path: "/program/edit/realisasi/:id",
    name: "Ubah Realisasi Fisik",
    component: program_edit_realisasi,
    meta: {
      title: "Ubah Realisasi Fisik"
    }
  },
  {
    path: "/program/pengecualian/:id",
    name: "Pengecualian Program",
    component: program_pengecualian,
    meta: {
      title: "Pengecualian Program"
    }
  },

  {
    path: "/program-perubahan",
    name: "Program Perubahan",
    component: program_perubahan,
    meta: {
      title: "Program Perubahan"
    }
  },
  {
    path: "/program-perubahan/detail/:id",
    name: "Detail Program Perubahan",
    component: program_perubahan_detail,
    meta: {
      title: "Detail Program Perubahan"
    }
  },
  {
    path: "/program-perubahan/add",
    name: "Tambah Program",
    component: program_perubahan_add,
    meta: {
      title: "Tambah Program Perubahan"
    }
  },
  {
    path: "/program-perubahan/edit/:id",
    name: "Ubah Program",
    component: program_perubahan_edit,
    meta: {
      title: "Ubah Program Perubahan"
    }
  },
  {
    path: "/program-perubahan/edit/realisasi/:id",
    name: "Ubah Realisasi Fisik",
    component: program_perubahan_edit_realisasi,
    meta: {
      title: "Ubah Realisasi Fisik Perubahan"
    }
  },
  {
    path: "/program-perubahan/pengecualian/:id",
    name: "Pengecualian Program",
    component: program_perubahan_pengecualian,
    meta: {
      title: "Pengecualian Program Perubahan"
    }
  },

  {
    path: "/program-p1",
    name: "Program P1",
    component: program_p1,
    meta: {
      title: "Program P1"
    }
  },
  {
    path: "/program-p1/detail/:id",
    name: "Detail Program P1",
    component: program_p1_detail,
    meta: {
      title: "Detail Program P1"
    }
  },
  {
    path: "/program-p1/add",
    name: "Tambah Program",
    component: program_p1_add,
    meta: {
      title: "Tambah Program P1"
    }
  },
  {
    path: "/program-p1/edit/:id",
    name: "Ubah Program",
    component: program_p1_edit,
    meta: {
      title: "Ubah Program P1"
    }
  },
  {
    path: "/program-p1/edit/realisasi/:id",
    name: "Ubah Realisasi Fisik",
    component: program_p1_edit_realisasi,
    meta: {
      title: "Ubah Realisasi Fisik P1"
    }
  },
  {
    path: "/program-p1/pengecualian/:id",
    name: "Pengecualian Program",
    component: program_p1_pengecualian,
    meta: {
      title: "Pengecualian Program P1"
    }
  },

  {
    path: "/laporan/perkembangan",
    name: "Laporan Perkembangan Fisik Dan Keuangan",
    component: laporan_perkembangan,
    meta: {
      title: "Laporan Perkembangan Fisik Dan Keuangan"
    }
  },
  {
    path: "/laporan/rekapitulasi",
    name: "Laporan Rekapitulasi",
    component: laporan_rekapitulasi,
    meta: {
      title: "Laporan Rekapitulasi"
    }
  },

  {
    path: "/laporan/kendala",
    name: "Laporan Kendala",
    component: laporan_kendala,
    meta: {
      title: "Laporan Kendala"
    }
  },

  {
    path: "/laporan/rekapitulasi-gabungan",
    name: "Laporan Rekapitulasi Gabungan",
    component: laporan_rekapitulasi_gabungan,
    meta: {
      title: "Laporan Rekapitulasi Gabungan"
    }
  },

  {
    path: "/laporan/capaian",
    name: "Laporan Capaian",
    component: laporan_capaian,
    meta: {
      title: "Laporan Capaian"
    }
  },

  {
    path: "/user",
    name: "Pegawai",
    component: user,
    meta: {
      title: "Pegawai"
    }
  },
  {
    path: "/user/detail/:id",
    name: "Detail Pegawai",
    component: user_detail,
    meta: {
      title: "Detail Pegawai"
    }
  },
  {
    path: "/user/add",
    name: "Tambah Pegawai",
    component: user_add,
    meta: {
      title: "Tambah Pegawai"
    }
  },
  {
    path: "/user/edit/:id",
    name: "Ubah Pegawai",
    component: user_edit,
    meta: {
      title: "Ubah Pegawai"
    }
  },

  {
    path: "/perbandingan-sp2d",
    name: "Perbandingan SP2D",
    component: perbandingan_sp2d,
    meta: {
      title: "Perbandingan SP2D"
    }
  },

  {
    path: "/laporan/rekap-opd-public",
    name: "Rekap OPD Public",
    component: laporan_rekap_opd_public,
    meta: {
      title: "Rekap OPD Public"
    }
  },
  
  {
    path: "/laporan/perkembangan-opd-public",
    name: "Perkembangan OPD Public",
    component: perkembangan_opd_public,
    meta: {
      title: "Perkembangan OPD Public"
    }
  },

  {
    path: "/laporan/summary-anggaran",
    name: "Summary Anggaran",
    component: laporan_summary_anggaran,
    meta: {
      title: "Summary Anggaran"
    }
  },

  {
    path: "/laporan/jumlah-program-kegiatan-sub",
    name: "Jumlah Program Kegiatan Sub Kegiatan",
    component: laporan_jumlah_program_kegiatan_sub,
    meta: {
      title: "Jumlah Program Kegiatan Sub Kegiatan"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})